import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Modal,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import useBasicProfile from "../../../../hooks/useBasicProfile";
import { assetContent, getAssets } from "../../../../store/reducers/asset";
import { saveProfilePictureFromUrl } from "../../../../store/reducers/profile";
import "./index.css";

const NFTSelectPage = (props: any) => {
  const { t } = useTranslation();
  const [currentCollection, setCurrentCollection] = useState<string>("");
  const { brandColor } = useAppSelector((state) => state.layout);
  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "315px",
    minWidth: "250px",
    height: "auto",
    bgcolor: "background.paper",
    boxShadow: 24,
    px: 4,
    pb: 2,
  };
  const {
    isFetchingCollection,
    collections: collectionList,
    assets: assetList,
    isFetchingAsset,
  } = useAppSelector((state) => state.asset);
  const { currentAddress } = useAppSelector((state) => state.auth);
  const { refetch } = useBasicProfile(currentAddress);
  const dispatch = useAppDispatch();
  const collections = collectionList[currentAddress] ?? [];
  const assets = assetList[currentAddress] ?? {};

  useEffect(() => {
    if (!collections.length || assets[collections[0].slug]) return;
    setCurrentCollection(collections[0].slug);
  }, [collections]);

  useEffect(() => {
    if (assets[currentCollection] || !currentCollection) return;
    dispatch(getAssets(currentCollection));
  }, [currentCollection]);

  const onAssetClick = (asset: assetContent) => {
    dispatch(
      saveProfilePictureFromUrl(asset.imageUrl, props.handleSetAlert, refetch)
    );
    props.onClose();
  };

  const getAssetView = () => {
    if (isFetchingAsset)
      return (
        <div className="NFTSelectModal-fetching">
          <CircularProgress style={{ color: brandColor }} size={20} />
        </div>
      );

    if (!assets[currentCollection] || !assets[currentCollection].length)
      return (
        <div className="NFTSelectModal-fetching">
          <h3>
            {t("Asset_Modal_NoAsset") + " "}
            {!!collections.length && (
              <>
                <br />
                <br />
                {t("Asset_Modal_NoAsset_2")}
              </>
            )}
          </h3>
        </div>
      );

    return assets[currentCollection]?.map((a, i) => (
      <div key={`asset_${i}`}>
        <Button
          size="small"
          type="button"
          className="NFTSelectModal-asset"
          onClick={() => {
            onAssetClick(a);
          }}
        >
          <img src={a.imageUrl} className="NFTSelectModal-asset-img" alt="" />
        </Button>
      </div>
    ));
  };

  return (
    <React.Fragment>
      <Modal
        hideBackdrop
        open={props.open}
        onClose={props.onClose}
        aria-labelledby="child-modal-title"
      >
        <Box sx={{ ...style }}>
          <h3
            id="child-modal-title"
            style={{ color: "#ddd", textAlign: "center", margin: "1.5em 0" }}
          >
            {t("FlashChat_Profile_ChooseNFTs")}
          </h3>
          <SimpleBar className="NFTSelectModal-asset-outer">
            {getAssetView()}
          </SimpleBar>
          <SimpleBar
            className="NFTSelectModal-button-outer"
            scrollbarMinSize={50}
          >
            {isFetchingCollection && (
              <div className="NFTSelectModal-fetching">
                <CircularProgress style={{ color: brandColor }} size={15} />
              </div>
            )}
            {!isFetchingCollection &&
              collections.map((c, i) => (
                <div key={`collection_${i}`} id={`collection_${i}`}>
                  <Tooltip title={c.name} arrow disableInteractive>
                    <Button
                      size="small"
                      className={`NFTSelectModal-button ${
                        currentCollection === c.slug && "active"
                      }`}
                      type="button"
                      onClick={(e) => {
                        setCurrentCollection(c.slug);
                      }}
                    >
                      <Avatar
                        src={c.imageUrl}
                        style={{
                          width: "37px",
                          height: "37px",
                          margin: "2px",
                        }}
                      />
                    </Button>
                  </Tooltip>
                </div>
              ))}
          </SimpleBar>
          <Button onClick={props.onClose} size="small">
            {t("FlashChat_Profile_Cancel")}
          </Button>
        </Box>
      </Modal>
    </React.Fragment>
  );
};

export default NFTSelectPage;
